(() => {
  const outsideQuickAdd = (el) =>
    el && !el.closest('quick-add-modal') && !el.closest('.quick-add-modal');

  const purgeModalStickies = () => {
    document.querySelectorAll('.gbi-sticky-atc').forEach((el) => {
      if (!outsideQuickAdd(el)) el.remove();
    });
  };

  // Always strip sticky bars that landed inside quick-add (duplicate IDs / wrong product).
  purgeModalStickies();

  if (window.__gbiStickyAtcInit) return;

  const bar = [...document.querySelectorAll('.gbi-sticky-atc')].find(outsideQuickAdd);
  if (!bar) return;

  window.__gbiStickyAtcInit = true;

  const sectionId = bar.dataset.sectionId;
  const btn = bar.querySelector('.gbi-sticky-atc__btn') || document.getElementById(`GbiStickyAtcBtn-${sectionId}`);
  const priceEl = bar.querySelector('.gbi-sticky-atc__price');
  const titleEl = bar.querySelector('.gbi-sticky-atc__title');
  const formId = bar.dataset.productForm;
  const FALLBACK_BAR_HEIGHT = 120;

  const getMainSection = () => {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    return outsideQuickAdd(section) ? section : null;
  };

  const getForm = () => {
    if (!formId) return null;
    const form = document.getElementById(formId);
    return outsideQuickAdd(form) ? form : null;
  };

  const isQuickAddOpen = () => Boolean(document.querySelector('quick-add-modal[open]'));
  const isCartDrawerOpen = () => Boolean(document.querySelector('cart-drawer.active'));

  if (titleEl && !titleEl.dataset.baseTitle) {
    titleEl.dataset.baseTitle = titleEl.textContent.trim();
  }

  const isLaidOut = (el) => {
    if (!el?.isConnected) return false;
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = el.getBoundingClientRect();
    return rect.height > 0 && rect.width > 0;
  };

  // Prefer the visible ATC — Addly often keeps the theme submit hidden and injects its own.
  const getSubmit = () => {
    const section = getMainSection();
    const form = getForm();
    const candidates = [
      document.getElementById(`ProductSubmitButton-${sectionId}`),
      section?.querySelector(`#ProductSubmitButton-${sectionId}`),
      ...(section ? [...section.querySelectorAll('[type="submit"].product-form__submit')] : []),
      ...(form ? [...form.querySelectorAll('[type="submit"].product-form__submit')] : []),
      ...(section ? [...section.querySelectorAll('.product-form__submit')] : []),
    ].filter((el, i, arr) => outsideQuickAdd(el) && arr.indexOf(el) === i);

    return candidates.find(isLaidOut) || candidates[0] || null;
  };

  // Always re-query — Addly may replace / hide the submit node after init.
  const getObserveTarget = () => {
    const submit = getSubmit();
    return isLaidOut(submit) ? submit : null;
  };

  const syncFromMain = () => {
    const submit = getSubmit();
    const priceSource =
      getMainSection()?.querySelector(`#price-${sectionId}`) ||
      (() => {
        const el = document.getElementById(`price-${sectionId}`);
        return outsideQuickAdd(el) ? el : null;
      })();
    if (priceSource && priceEl) {
      const visible =
        priceSource.querySelector('.price__sale .price-item--sale') ||
        priceSource.querySelector('.price-item--last') ||
        priceSource.querySelector('.price-item');
      if (visible) priceEl.textContent = visible.textContent.trim();
    }
    if (titleEl) {
      const base = titleEl.dataset.baseTitle || titleEl.textContent.trim();
      const section = getMainSection();
      const option =
        section?.querySelector('variant-selects .select__select') ||
        section?.querySelector('variant-selects select');
      const checkedRadio = section?.querySelector('variant-radios input[type="radio"]:checked');
      let variantLabel = '';
      if (option && outsideQuickAdd(option)) {
        const selected = option.options?.[option.selectedIndex];
        variantLabel = selected?.textContent?.trim() || '';
      } else if (checkedRadio && outsideQuickAdd(checkedRadio)) {
        variantLabel = checkedRadio.value || checkedRadio.nextElementSibling?.textContent?.trim() || '';
      }
      if (variantLabel && variantLabel.toLowerCase() !== 'default title') {
        titleEl.textContent = `${base} · ${variantLabel}`;
      } else {
        titleEl.textContent = base;
      }
    }
    if (submit && btn) {
      const disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      btn.disabled = disabled;
      const label = submit.querySelector('span')?.textContent?.trim();
      if (label) btn.textContent = label;
    }
  };

  const setBarVisible = (show) => {
    if (isQuickAddOpen() || isCartDrawerOpen()) {
      bar.classList.remove('is-visible');
      bar.hidden = true;
      return;
    }
    bar.classList.toggle('is-visible', show);
    bar.hidden = !show;
  };

  let cachedBarHeight = FALLBACK_BAR_HEIGHT;

  // Measure via clone so we never disturb live visibility (avoids race with show/hide).
  const measureBarHeight = () => {
    const clone = bar.cloneNode(true);
    clone.removeAttribute('id');
    clone.hidden = false;
    clone.classList.add('is-visible');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.cssText =
      'position:fixed;left:-9999px;right:auto;bottom:0;width:390px;max-width:100vw;visibility:hidden;pointer-events:none;display:grid;';
    document.body.appendChild(clone);
    const height = Math.round(clone.getBoundingClientRect().height) || FALLBACK_BAR_HEIGHT;
    clone.remove();
    cachedBarHeight = Math.max(height, 1);
    return cachedBarHeight;
  };

  // Geometry check always uses the live submit node (survives Addly swaps).
  // Sticky shows only when the main ATC is fully outside the safe viewport.
  const updateVisibility = () => {
    if (isQuickAddOpen() || isCartDrawerOpen()) {
      setBarVisible(false);
      return;
    }
    const target = getObserveTarget();
    if (!target) {
      setBarVisible(false);
      return;
    }
    const rect = target.getBoundingClientRect();
    const cut = cachedBarHeight || FALLBACK_BAR_HEIGHT;
    const onScreen = rect.bottom > 0 && rect.top < window.innerHeight - cut && rect.height > 0;
    setBarVisible(!onScreen);
  };

  let rafPending = false;
  const scheduleUpdate = () => {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      updateVisibility();
    });
  };

  measureBarHeight();
  updateVisibility();

  const scrollOpts = { passive: true, capture: true };
  window.addEventListener('scroll', scheduleUpdate, scrollOpts);
  document.addEventListener('scroll', scheduleUpdate, scrollOpts);
  window.addEventListener('resize', () => {
    measureBarHeight();
    scheduleUpdate();
  }, { passive: true });
  window.addEventListener('orientationchange', () => {
    measureBarHeight();
    scheduleUpdate();
  }, { passive: true });

  const formRoot = getForm()?.closest('product-form') || getForm() || getMainSection();
  if (formRoot) {
    new MutationObserver(() => {
      syncFromMain();
      scheduleUpdate();
    }).observe(formRoot, { childList: true, subtree: true });
  }

  btn?.addEventListener('click', () => {
    if (isQuickAddOpen() || isCartDrawerOpen()) return;
    purgeModalStickies();
    const currentSubmit = getSubmit();
    if (!currentSubmit || currentSubmit.disabled) return;
    currentSubmit.click();
  });

  const onOverlayChange = () => {
    purgeModalStickies();
    scheduleUpdate();
  };

  document.addEventListener('toggle', onOverlayChange, true);
  document.querySelectorAll('quick-add-modal').forEach((modal) => {
    new MutationObserver(onOverlayChange).observe(modal, {
      attributes: true,
      attributeFilter: ['open'],
    });
  });
  document.querySelectorAll('cart-drawer').forEach((drawer) => {
    new MutationObserver(onOverlayChange).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data?.sectionId || String(data.sectionId) !== String(sectionId)) return;
      if (String(data.sectionId).includes('quickadd')) return;
      syncFromMain();
      scheduleUpdate();
    });
  }

  syncFromMain();
  // Late Addly mount / layout settle
  setTimeout(() => {
    measureBarHeight();
    updateVisibility();
  }, 800);
  setTimeout(() => {
    measureBarHeight();
    updateVisibility();
  }, 2000);
})();
